import React from "react";

import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneInput, { Country } from "react-phone-number-input";

import { ErrorMessage } from "@components/inputs/shared";
import {
	getDefaultCountryCodeForTheme,
	isPhoneValidOnRegistration,
} from "@utils";

export default function OnboardingRegistrationPhone(props: {
	inputClassName: string;
}) {
	const translationHook = useTranslation("registration");

	const { getValues } = useFormContext();

	const defaultCountryCode = getDefaultCountryCodeForTheme();

	return (
		<div className="form__field u-mar--bottom--reset">
			<label htmlFor="phoneNumber" className="label label--strong">
				{translationHook.t<string>("MOBILE_PHONE_LABEL")}
			</label>

			<ErrorMessage name="mobilePhone" />
			<Controller
				name="mobilePhone"
				rules={{
					validate: {
						isPhoneValidOnRegistration: async (e) => {
							const valid = await isPhoneValidOnRegistration(e);
							return valid
								? true
								: "COMMON.INVALID_PHONE";
						},
					},
				}}
				render={({ field }) => {
					return (
						<PhoneInput
							id="phoneNumber"
							className={
								"input input--sml " + props.inputClassName
							}
							international
							defaultCountry={defaultCountryCode as Country}
							onChange={field.onChange}
							value={getValues("mobilePhone")}
						/>
					);
				}}
			/>
		</div>
	);
}
